import {cardToCardService} from "@/common/api.service"
import {onlineContractService} from "../../common/api.service";

const initialStates = {
    templates: [],
    form_data: {},
    general_wage_setting : {},
    template : {},
    template_status : 'loading',
    general_wage_setting_status : 'loading',
    contract: {},
    contract_status: 'loading',
    contract_statistics: '',
    contract_statistics_status: 'loading'
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    loadingGeneralWageSetting(state) {
        state.general_wage_setting_status = 'loading'
    },
    loadingTemplateStatus(state) {
        state.template_status = 'loading'
    },
    templateStatusSuccess(state , template) {
        state.template = template
        state.template_status = 'success'
    },
    generalWageSettingSuccess(state, settings) {
        state.general_wage_setting = settings
        state.general_wage_setting_status = 'success'
    },
    setFormData(state, form_data) {
        state.form_data = form_data
    },
    clearFormData(state) {
        state.status = 'clearFormData'
        Object.keys(state.form_data).forEach(function (key) {
            state.form_data[key] = ''
        });
    },
    loadingContractStatus(state) {
        state.contract_status = 'loading'
    },
    contractStatusSuccess(state , contract) {
        state.contract = contract
        state.contract_status = 'success'
    },
    loadingContractStatisticsStatus(state) {
        state.contract_status = 'loading'
    },
    contractStatisticsStatusSuccess(state , contract_statistics) {
        state.contract_statistics = contract_statistics
        state.contract_statistics_status = 'success'
    },
}

const getters = {
    form_data: ({form_data}) => form_data,
    general_wage_setting: ({general_wage_setting}) => general_wage_setting,
    general_wage_setting_status: ({general_wage_setting_status}) => general_wage_setting_status,
    template: ({template}) => template,
    template_status: ({template_status}) => template_status,
    contract: ({contract}) => contract,
    contract_status: ({contract_status}) => contract_status,
    contract_statistics: ({contract_statistics}) => contract_statistics,
    contract_statistics_status: ({contract_statistics_status}) => contract_statistics_status,
}

const actions = {
    fetchGeneralWageSetting({commit}, hashid) {
        commit('loadingGeneralWageSetting')
        return onlineContractService.fetchGeneralWageSetting().then(response => {
            commit('generalWageSettingSuccess', response.data.data)
        })
    },
    findTemplate({commit}, hashid) {
        commit('loadingTemplateStatus')
        return onlineContractService.findTemplate(hashid).then(response => {
            commit('templateStatusSuccess', response.data.data)
        })
    },
    findContract({commit}, hashid) {
        commit('loadingContractStatus')
        return onlineContractService.findContract(hashid).then(response => {
            commit('contractStatusSuccess', response.data.data)
        })
    },
    getContractStatistics({commit}, query) {
        commit('loadingContractStatisticsStatus')
        return onlineContractService.getContractStatistics(query).then(response => {
            commit('contractStatisticsStatusSuccess', response.data.data)
        })
    }
}


export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}